import * as React from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { datePickerStyles, openPickerButtonStyles, inputAdornmentStyles } from './datePickerStyles';

const DatePickers = ({ value, onChange, placeholder, bgColor, label, helperText, disableFuture, focusColor, minDate, maxDate }) => {
  const inputRef = React.useRef(null);

  const handleLabelClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className='flex flex-col gap-1 w-full'>
      {label && <span className='text-[#8B8E98] text-[10px] cursor-default' onClick={handleLabelClick}>{label}</span>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value ? dayjs(value) : null}
          disableFuture={disableFuture}
          onChange={(newValue) => {
            if (newValue) {
              onChange(newValue.format("MM-DD-YYYY"));
            } else {
              onChange(""); // Handle clearing the date
            }
          }}
          format="MM-DD-YYYY"
          maxDate={maxDate ? dayjs(maxDate) : null}
          minDate={minDate ? dayjs(minDate) : null}
          slotProps={{
            textField: {
              placeholder: placeholder,
              sx: {
                ...datePickerStyles(bgColor, focusColor),
                '@media (max-width: 992px)': {
                  minWidth: '155px',  // Apply min-width on larger screens
                },
              },
              inputRef: inputRef,
              error: !!helperText,
              helperText: helperText,
            },
            openPickerButton: openPickerButtonStyles,
            inputAdornment: inputAdornmentStyles,
            
            // popper: {
            //   // sx: datePickerCalendarStyles, // Apply styles when DatePicker opens
            // },
            // desktopPaper: {
            //   // sx: datePickerCalendarStyles, // Styles for desktop variant
            // },
            // mobilePaper: {
            // //   sx: datePickerCalendarStyles, // Styles for mobile variant
            // },
          }}
        />
      </LocalizationProvider>
      {helperText && <span className='text-[#d32f2f] text-[10px] text-errorMessage'>{helperText}</span>}
    </div>
  );
}

export default DatePickers;